import { Box, Flex, styled } from '@ghq-abi/design-system';

export const StepperContainer = styled(Flex, {
  placeSelf: 'center',
  alignItems: 'center',
  marginBottom: '$10',
  position: 'relative',
  width: '100%',
  bg: '$white',
});

export const Step = styled(Box, {
  display: 'flex',
  flex: '1 1',
  flexDirection: 'column',
  position: 'relative',

  variants: {
    position: {
      center: {
        alignItems: 'center',
      },
      end: {
        alignItems: 'flex-end',
        paddingRight: '$1-5',
      },
      start: {
        alignItems: 'flex-start',
        paddingLeft: '$1-5',
      },
    },
  },

  defaultVariants: {
    position: 'center',
  },
});

export const StepNumber = styled(Box, {
  alignItems: 'center',
  background: 'white',
  border: '2px solid #ccc',
  borderRadius: '50%',
  display: 'flex',
  fontWeight: 'bold',
  height: '$7',
  justifyContent: 'center',
  position: 'relative',
  width: '$7',
  zIndex: 2,

  variants: {
    status: {
      active: {
        background: '#E5B611',
        borderColor: '$gray200',
        color: 'white',
      },
      completed: {
        background: '#28a745',
        borderColor: '$gray200',
        color: 'white',
      },
      pending: {
        background: 'white',
        borderColor: '#ccc',
        fontWeight: 500,
        color: '#333',
      },
    },
  },
});

export const StepLabel = styled(Flex, {
  alignItems: 'center',
  display: 'flex',
  fontSize: '$sm',
  marginTop: '$1',
});

export const ProgressBar = styled(Box, {
  background: '#ccc',
  borderRadius: '$2',
  height: '$1-5',
  left: 0,
  position: 'absolute',
  top: '28%',
  width: '100%',
  zIndex: 1,
});

export const ProgressFill = styled(Box, {
  background: '#28a745',
  borderRadius: '$2',
  height: '100%',
  left: 0,
  position: 'absolute',
  top: 0,
});
